import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'
import { State } from 'store/reducers/index.types'
import {
  getScreenSize,
  getUri
} from 'store/selectors'
import { MapStateToProps } from './types'

const mapStateToProps = (state: State): MapStateToProps => ({
  p: getP(state),
  pathname: getUri(state),
  screenSize: getScreenSize(state)
})

export default connect(mapStateToProps)
